import MailOpenedIcon from '@/icons/mail-opened.svg';
import MailIcon from '@/icons/mail.svg';
import PhoneIcon from '@/icons/phone.svg';
import { GeneralSettings } from '@/types';
import DialogButton from '@components/DialogButton';
import RawHtml from '@components/RawHtml';
import TeamMember from '@components/TeamMember';
import { phoneForLinks } from '@utils/phone';
import Link from 'next/link';

type Props = {
  settings: GeneralSettings | null | undefined;
  toggleOpen?: () => void;
};

function ContactModal(props: Props) {
  const { settings, toggleOpen } = props;
  if (!settings) {
    return null;
  } else {
    return (
      <DialogButton
        buttonClass='button button--primary menu-contact'
        aria-label={settings?.contact_page_link_text}
        buttonText={
          <>
            <PhoneIcon /> <span>{settings?.contact_page_link_text}</span>
          </>
        }
        dialogClass='contact-modal'
        toggleOpen={toggleOpen}
      >
        {settings.phone ? (
          <div className='contact-modal__phone'>
            <Link
              className='contact-modal__phone-link'
              href={`tel:${phoneForLinks(settings.phone)}`}
              aria-label={settings.phone}
            >
              <PhoneIcon />
              {settings.phone}
            </Link>
          </div>
        ) : null}

        {settings.email ? (
          <div className='contact-modal__mail'>
            <Link
              href={`mailto:${settings.email}`}
              className='contact-modal__mail-link button button--primary'
              aria-label='Per E-Mail kontaktieren'
            >
              <MailIcon /> <span>Per E-Mail kontaktieren</span>
            </Link>
          </div>
        ) : null}
        <div className='contact-modal__mid-section'>
          {settings.counselling_text ? (
            <div className='contact-modal__address'>
              <RawHtml html={settings.counselling_text} />
            </div>
          ) : null}
          {settings.general_contact_person ? (
            <TeamMember person={settings.general_contact_person} context='contact' />
          ) : null}
        </div>
        {settings.newsletter_page ? (
          <div className='contact-modal__newsletter'>
            <Link
              href={settings.newsletter_page.full_url}
              className='contact-modal__newsletter-link button button--ghost button--white'
            >
              <MailOpenedIcon />
              <span>Newsletter abonnieren</span>
            </Link>
          </div>
        ) : null}
      </DialogButton>
    );
  }
}

export default ContactModal;
